import { render, staticRenderFns } from "./vehicle_status_history.vue?vue&type=template&id=1301768c&scoped=true&"
import script from "./vehicle_status_history.vue?vue&type=script&lang=js&"
export * from "./vehicle_status_history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1301768c",
  null
  
)

export default component.exports